import smoothscroll from 'smoothscroll-polyfill';

// kick off the polyfill!
smoothscroll.polyfill();

(function handleScrollTop() {
  const btnScrollTop = document.querySelector('.btn-scroll-top');
  if (!btnScrollTop) return;

  btnScrollTop.addEventListener('click', () => {
    window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
  });

  window.addEventListener('scroll', () => {
    if (document.body.scrollTop > 500 || document.documentElement.scrollTop > 500) {
      btnScrollTop.classList.add('show');
    } else {
      btnScrollTop.classList.remove('show');
    }
  });
})();
